import React from 'react'

function PrivacyPolicy() {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", lineHeight: 1.7, padding: 16, color: "#333" }}>
      <h2>Privacy Policy</h2>
      <p><strong>Last updated:</strong> 12 Sep 2025</p>

      <p>
        Eagle OBC LLC (“we”, “our”, or “us”) is committed to protecting your personal data and respecting your privacy.
        This Privacy Policy explains how we collect, use, and protect your information when you use our website,
        mobile application, and services.
      </p>

      <p>
        We comply with the General Data Protection Regulation (GDPR), the Austrian Data Protection Act (DSG),
        and other applicable data protection laws.
      </p>

      <h3>1. Controller</h3>
      <p>
        <strong>Eagle OBC LLC</strong><br />
        Nauschgasse 4/3/2 1143<br />
        1220 Vienna, Austria<br />
        Email: ops@eagleobc.com
      </p>

      <h3>2. Data We Collect</h3>
      <ul>
        <li>Name, email address, phone number, and company details</li>
        <li>Account and profile information</li>
        <li>Uploaded images such as profile photos, delivery proof, and documents</li>
        <li>Location data (foreground and background during active deliveries)</li>
        <li>Technical information such as IP address, device type, and app usage data</li>
      </ul>

      <h3>3. Purpose of Processing</h3>
      <ul>
        <li>Account creation and management</li>
        <li>Parcel delivery and logistics services</li>
        <li>Real-time delivery tracking and navigation</li>
        <li>Sharing live delivery status with customers</li>
        <li>Processing payments and invoices</li>
      </ul>

      <h3>4. Legal Basis for Processing</h3>
      <ul>
        <li>Consent (Art. 6(1)(a) GDPR)</li>
        <li>Contractual necessity (Art. 6(1)(b) GDPR)</li>
        <li>Legal obligation (Art. 6(1)(c) GDPR)</li>
        <li>Legitimate interests (Art. 6(1)(f) GDPR)</li>
      </ul>

      <h3>5. Data Sharing and Transfers</h3>
      <p>
        Data may be shared with customers during active deliveries and with trusted service providers such as
        Hostinger, Stripe, Plutio, and Lexoffice. Data may be transferred to the EU, USA, and Brazil with
        appropriate safeguards.
      </p>

      <h3>6. Data Retention</h3>
      <p>
        Personal data is retained only as long as necessary to fulfill service and legal obligations.
      </p>

      <h3>7. Your Rights</h3>
      <p>
        You have the right to access, correct, delete, restrict, or object to processing of your data and
        withdraw consent at any time.
      </p>

      <h3>8. Security</h3>
      <p>
        We implement appropriate technical and organizational measures to protect personal data.
      </p>

      <h3>9. Cookies & Tracking</h3>
      <p>
        Cookies may be used to ensure proper website functionality and improve user experience.
      </p>

      <h3>10. Children’s Privacy</h3>
      <p>
        Our services are not intended for children under 16 years of age.
      </p>

      <h3>11. Changes to This Policy</h3>
      <p>
        This Privacy Policy may be updated periodically. Changes will be published with an updated date.
      </p>

      <h3>12. Contact</h3>
      <p>
        <strong>Eagle OBC LLC</strong><br />
        Email: ops@eagleobc.com<br />
        Vienna, Austria
      </p>
    </div>
  )
}

export default PrivacyPolicy